import {makeType,actionCreator} from '../../Utils/generateActionCreator';

const actionType = makeType('POLICY');

export const ADD_CLIENT = actionType('ADD_CLIENT')
export const QUOTE_DATA_MODAL = actionType('QUOTE_DATA_MODAL')
export const UPDATE_CLIENT = actionType('UPDATE_CLIENT')
export const SAVE_ACTIVE_PRODUCT_CODE = actionType('SAVE_ACTIVE_PRODUCT_CODE')

export const addClient = actionCreator(ADD_CLIENT,'client')
export const quoteDataModal = actionCreator(QUOTE_DATA_MODAL,'quoteDataModal')
export const updateClient = actionCreator(UPDATE_CLIENT,'otherDataClient')
export const saveACtiveProductCode = actionCreator(SAVE_ACTIVE_PRODUCT_CODE,'saveActiveProductCode')


